<template>
  <div class="options">
    <button
      v-for="option in options"
      :key="option"
      :class="['options__button', { '-selected': value === option }]"
      @click.prevent="select(option)"
    >
      <span class="options__label">{{ option }}</span>
    </button>

    <p v-if="error" class="options__error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'InputOptions',
  props: {
    value: { type: String, default: '' },
    options: { type: Array, default: Array },
    error: { type: String, default: null }
  },
  methods: {
    select(option) {
      this.$emit('focus')
      this.$emit('input', option)
    }
  }
}
</script>
